"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = exports.chipCssVars = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _ButtonBase = _interopRequireDefault(require("../ButtonBase"));
var _Label = _interopRequireDefault(require("../Label"));
var _tss = require("../styles/tss");
var _responsiveProps = require("../utilities/responsiveProps");
var _unitConversion = require("../utilities/unitConversion");
var _useForkRef = _interopRequireDefault(require("../utilities/useForkRef"));
const _excluded = ["classes", "className", "clickable", "color", "component", "endIcon", "disabled", "hovered", "label", "startIcon", "onClick", "onKeyDown", "onKeyUp", "size", "variant", "noWrap"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function resetLineHeight() {
  let cssFontSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  let resetToEm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  const [fontSize] = (0, _unitConversion.getValueAndUnit)(cssFontSize);
  if (typeof fontSize === 'string') {
    return resetToEm;
  }
  return resetToEm / fontSize;
}
function withBorder(spacingValue) {
  return spacingValue - 0.125;
}
const chipCssVars = exports.chipCssVars = {
  chipBackground: '--chip-background',
  chipBorderColor: '--chip-border-color',
  chipColor: '--chip-color',
  chipIconColor: '--chip-icon-color',
  chipHoverBackground: '--chip-hover-background',
  chipHoverBorderColor: '--chip-hover-border-color',
  chipHoverColor: '--chip-hover-color',
  chipHoverIconColor: '--chip-hover-icon-color',
  chipActiveBackground: '--chip-active-background',
  chipActiveBorderColor: '--chip-active-border-color',
  chipActiveColor: '--chip-active-color',
  chipActiveIconColor: '--chip-active-icon-color'
};
const useStyles = exports.useStyles = (0, _tss.makeTssStyles)({
  name: 'DsChip',
  uniqId: 'OCdR5Y'
})((theme, _, classes) => {
  const {
    transitions,
    busbud: {
      styles,
      spacing,
      typography
    }
  } = theme;
  const hover = `.${classes.clickable}.${classes.hovered}&, .${classes.clickable}&:hover, .${classes.clickable}&:focus`;
  const active = `.${classes.clickable}&:active`;
  const icon = `& .${classes.startIcon}, & .${classes.endIcon}`;
  const sizeCssDefinitions = {
    size: {
      sm: {
        minHeight: spacing(3),
        padding: spacing(withBorder(0.5), withBorder(1.25))
      },
      md: {
        minHeight: spacing(4),
        padding: spacing(withBorder(1), withBorder(2))
      },
      lg: {
        minHeight: spacing(5),
        padding: spacing(withBorder(1), withBorder(2.5))
      }
    }
  };
  const labelCssDefinitions = {
    label: {
      sm: {
        // Set line-height to 16px to avoid cuts due to overflow hidden
        lineHeight: `${resetLineHeight(typography.font.component.label.sm.fontSize)}!important`
      },
      md: {}
    }
  };
  const startIconCssDefinitions = {
    startIconSize: {
      lg: {
        paddingLeft: spacing(withBorder(1.5))
      },
      md: {
        paddingLeft: spacing(withBorder(1.5))
      },
      sm: {
        paddingLeft: spacing(withBorder(0.75))
      }
    }
  };
  const endIconCssDefinitions = {
    endIconSize: {
      lg: {
        paddingRight: spacing(withBorder(1.5))
      },
      md: {
        paddingRight: spacing(withBorder(1.5))
      },
      sm: {
        paddingRight: spacing(withBorder(0.75))
      }
    }
  };
  const responsiveStyles = (0, _responsiveProps.generateUnoptimizedResponsiveStyles)(theme, _objectSpread(_objectSpread({}, labelCssDefinitions), sizeCssDefinitions));
  const startIconResponsiveStyles = (0, _responsiveProps.generateUnoptimizedResponsiveStyles)(theme, startIconCssDefinitions);
  const endIconResponsiveStyles = (0, _responsiveProps.generateUnoptimizedResponsiveStyles)(theme, endIconCssDefinitions);
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, responsiveStyles), {}, {
    root: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderStyle: 'solid',
      borderWidth: styles.borderWidth.sm,
      borderRadius: styles.rounding.pill,
      transition: transitions.create(['background-color'], {
        duration: transitions.duration.shortest
      }),
      cursor: 'inherit',
      outline: 0,
      background: `var(${chipCssVars.chipBackground})`,
      borderColor: `var(${chipCssVars.chipBorderColor})`,
      color: `var(${chipCssVars.chipColor})`,
      [icon]: {
        color: `var(${chipCssVars.chipIconColor})`
      },
      [hover]: {
        background: `var(${chipCssVars.chipHoverBackground})`,
        borderColor: `var(${chipCssVars.chipHoverBorderColor})`,
        color: `var(${chipCssVars.chipHoverColor})`,
        [icon]: {
          color: `var(${chipCssVars.chipHoverIconColor})`
        }
      },
      [active]: {
        background: `var(${chipCssVars.chipActiveBackground})`,
        borderColor: `var(${chipCssVars.chipActiveBorderColor})`,
        color: `var(${chipCssVars.chipActiveColor})`,
        [icon]: {
          color: `var(${chipCssVars.chipActiveIconColor})`
        }
      }
    },
    label: {},
    disabled: {
      pointerEvents: 'none',
      opacity: theme.busbud.styles.component.chip.stateDisabled.opacity
    },
    hovered: {}
  }, startIconResponsiveStyles), {}, {
    startIcon: {
      marginRight: spacing(0.75)
    }
  }, endIconResponsiveStyles), {}, {
    endIcon: {
      marginLeft: spacing(0.75)
    },
    clickable: {
      textDecoration: 'none',
      // Prevent link underlining.
      userSelect: 'none',
      cursor: 'pointer'
    }
  });
});
function isDeleteKeyboardEvent(keyboardEvent) {
  return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
function getSizeClassname(size, classes, prefix) {
  return (0, _responsiveProps.getResponsiveClassNamesForProp)(size, prefix).map(className => classes[className]);
}

/**
 * **❗️ DEPRECATED**: Use the new `Chip` component from `@busbud/horizon` - [Storybook](https://main--66e336a480b3d19fa782310f.chromatic.com/?path=/docs/data-display-chip):
 *
 * ```tsx
 * import { Chip } from "@busbud/horizon";
 * ```
 *
 * [Storybook](https://busbud.github.io/horizon-web-ui-kit/?path=/docs/data-display-chip)
 *
 * @deprecated
 */
const Chip = /*#__PURE__*/React.forwardRef(function Chip(props, ref) {
  const {
      classes: classesOverrides,
      className,
      clickable: clickableProp,
      color = 'neutral',
      component: ComponentProp,
      endIcon: endIconProp,
      disabled = false,
      hovered = false,
      label,
      startIcon: startIconProp,
      onClick,
      onKeyDown,
      onKeyUp,
      size = 'md',
      variant = 'default',
      noWrap = true
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  const {
    classes,
    cx,
    theme
  } = useStyles(undefined, {
    props: {
      classes: classesOverrides
    }
  });

  //css vars wrapped in usememo to avoid re-rendering
  const cssVarsValues = React.useMemo(() => {
    const chip = theme.busbud.colors.component.chip[color];
    const chipVariant = chip[variant];
    return {
      [chipCssVars.chipBackground]: chipVariant.normal.background,
      [chipCssVars.chipBorderColor]: chipVariant.normal.border || 'transparent',
      [chipCssVars.chipColor]: chipVariant.normal.text,
      [chipCssVars.chipIconColor]: chipVariant.normal.icon,
      // hover
      [chipCssVars.chipHoverBackground]: chipVariant.hover.background || chipVariant.normal.background,
      [chipCssVars.chipHoverBorderColor]: chipVariant.hover.border || chipVariant.normal.border || 'transparent',
      [chipCssVars.chipHoverColor]: chipVariant.hover.text || chipVariant.normal.text,
      [chipCssVars.chipHoverIconColor]: chipVariant.hover.icon || chipVariant.normal.icon,
      // active
      [chipCssVars.chipActiveBackground]: chipVariant.active.background || chipVariant.normal.background,
      [chipCssVars.chipActiveBorderColor]: chipVariant.active.border || chipVariant.normal.border || 'transparent',
      [chipCssVars.chipActiveColor]: chipVariant.active.text || chipVariant.normal.text,
      [chipCssVars.chipActiveIconColor]: chipVariant.active.icon || chipVariant.normal.icon
    };
  }, [color, variant, theme]);
  const chipRef = React.useRef(null);
  const handleRef = (0, _useForkRef.default)(chipRef, ref);
  const handleKeyDown = event => {
    // Ignore events from children of `Chip`.
    if (event.currentTarget === event.target && isDeleteKeyboardEvent(event)) {
      // will be handled in keyUp, otherwise some browsers
      // might init navigation
      event.preventDefault();
    }
    if (onKeyDown) {
      onKeyDown(event);
    }
  };
  const handleKeyUp = event => {
    // Ignore events from children of `Chip`.
    if (event.currentTarget === event.target) {
      if (event.key === 'Escape' && chipRef.current) {
        // @ts-ignore - chipRef.current is checked above
        chipRef.current.blur();
      }
    }
    if (onKeyUp) {
      onKeyUp(event);
    }
  };
  const clickable = clickableProp !== false && onClick ? true : clickableProp;
  const Component = ComponentProp || (clickable ? _ButtonBase.default : 'div');
  const moreProps = Component === _ButtonBase.default ? {
    component: 'div'
  } : {};
  let EndIcon = null;
  if (endIconProp && /*#__PURE__*/React.isValidElement(endIconProp)) {
    EndIcon = /*#__PURE__*/React.cloneElement(endIconProp, {
      className: cx(classes.endIcon, endIconProp.props.className)
    });
  }
  let StartIcon = null;
  if (startIconProp && /*#__PURE__*/React.isValidElement(startIconProp)) {
    StartIcon = /*#__PURE__*/React.cloneElement(startIconProp, {
      className: cx(classes.startIcon, startIconProp.props.className)
    });
  }
  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
    role: clickable ? 'button' : undefined,
    style: cssVarsValues,
    className: cx(classes.root, ...getSizeClassname(size, classes, 'size'), !!startIconProp && getSizeClassname(size, classes, 'startIconSize'), !!endIconProp && getSizeClassname(size, classes, 'endIconSize'), {
      [classes.disabled]: disabled,
      [classes.hovered]: hovered && clickable && !disabled,
      [classes.clickable]: clickable
    }, className),
    "aria-disabled": disabled || undefined,
    tabIndex: clickable ? 0 : undefined,
    onClick: onClick,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    ref: handleRef
  }, moreProps, other), StartIcon, /*#__PURE__*/React.isValidElement(label) ? label : /*#__PURE__*/React.createElement(_Label.default, {
    size: size,
    fontWeight: "bold",
    noWrap: noWrap,
    className: cx(classes.label, ...getSizeClassname(size, classes, 'label'))
  }, label), EndIcon);
});
var _default = exports.default = Chip;